// extracted by mini-css-extract-plugin
export default {"reflexible":"FlexibleContent_reflexible__Q7ad3","reflexibleTry":"FlexibleContent_reflexibleTry__Ggmkd","reflexibleFailback":"FlexibleContent_reflexibleFailback__6Eg08"};